export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9927.7cc6917a.jpg";